import { render, staticRenderFns } from "./channelView.vue?vue&type=template&id=2d121684&scoped=true"
import script from "./channelView.vue?vue&type=script&lang=js"
export * from "./channelView.vue?vue&type=script&lang=js"
import style0 from "./channelView.vue?vue&type=style&index=0&id=2d121684&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d121684",
  null
  
)

export default component.exports